import { Link } from 'react-router-dom'

function SideRow({ label, to }) {
  return (
    <Link
      to={to}
      className="flex justify-between items-center py-3 border-b border-soft-rule text-[14px] text-soft-ink no-underline hover:text-soft-dim transition-colors group"
    >
      <span>{label}</span>
      <span className="font-mono text-[12px] text-soft-faint group-hover:text-soft-dim transition-colors">→</span>
    </Link>
  )
}

export default SideRow
